export const EVENT_DEFAULT_IMAGE_PATH = '/images/bg-landing.png';
export const EVENT_LOCATION_FULL =
  '(k)lubovňa SL, Námestie svätého Mikuláša 23/23, 064 01 Stará Ľubovňa, Slovensko';
export const EVENT_DESCRIPTION_FALLBACK = '(k)lubovňa SL event';
export const EVENT_DESCRIPTION_MAX_LENGTH = 200;
export const EVENT_SITE_TITLE = '(k)lubovňa SL';
